import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// This clinic has no page on the new site. Send visitors to the market page,
// which has booking and the quote form, as the WordPress site did. The state
// hub would send them back to the page they clicked from.
export const Route = createFileRoute("/locations/colorado/downtown-denver")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/locations/restore-denver/", location.searchStr), statusCode: 301 });
  },
});
